// import moment from 'moment';
var moment = require('moment-timezone');

function getItemPrice(itemId, items) {
  if (items.hasOwnProperty(itemId)) return items[itemId].price;
  else return -1;
}

export function calcSpecificDiscount(body) {
  let {
    req, appliedToCart, evaluateCart,
    selectedQuantity, discountQuantity,
    itemPrice, cartPrice, discountPrice, curAmtSaved
  } = body;

  // ----------------- GROUP ----------------- //
  if (req.applicable_to_id === '1' && req.condition_id === '1') { // Group && FEGO
    discountQuantity = Math.floor(selectedQuantity / req.item_quantity);
    discountPrice = req.discount_amount;

    if (req.is_percent) discountPrice = itemPrice * (req.discount_amount / 100);
    curAmtSaved = discountPrice * discountQuantity;
  } // ----------------- CART ----------------- //
  else if (req.applicable_to_id === '2') { // Cart
    appliedToCart = true;
    discountQuantity = 1;
    if (req.is_percent) {
      // req.condition_id === CE or CAL
      curAmtSaved = cartPrice * (req.discount_amount / 100);
    } else {
      curAmtSaved = req.discount_amount;
    }
    if (!evaluateCart) { // can't be percentages
      if (req.condition_id === '1') { // FEGO
        discountPrice *= discountQuantity;
      }
    }
  } // ----------------- ITEM ----------------- //
  else if (req.applicable_to_id === '3') { // Item
    if (req.is_percent) curAmtSaved = itemPrice;
    else curAmtSaved = req.discount_amount;

    if (req.condition_id === '1') { // FEGO
      discountQuantity = Math.floor(selectedQuantity / req.item_quantity);
      curAmtSaved *= req.item_quantity * discountQuantity;
    }
    else if (req.condition_id === '2') { // CAL
      curAmtSaved *= selectedQuantity;
      discountQuantity = selectedQuantity;
    }
    else if (req.condition_id === '3') { // CE
      curAmtSaved *= req.item_quantity;
      discountQuantity = req.item_quantity;
    }
    else if (req.condition_id === '4') { // CAM

      if(selectedQuantity > req.item_quantity) {
        curAmtSaved *= req.item_quantity;
        discountQuantity = req.item_quantity;
      } else {
        curAmtSaved *= selectedQuantity;
        discountQuantity = selectedQuantity;
      }

    }

    if (req.is_percent) {
      curAmtSaved *= (req.discount_amount / 100);
      if (req.condition_id !== '1') {
        discountPrice = itemPrice * (req.discount_amount / 100);
      }
    }
  }

  return {
    req, appliedToCart, evaluateCart,
    selectedQuantity, discountQuantity,
    itemPrice, cartPrice, discountPrice, curAmtSaved
  };
}

function calcAmtSaved(req, ts, items, cartPrice) {
  let body = {
    req,
    appliedToCart: false, // doesn't matter
    evaluateCart: false, // doesn't matter
    selectedQuantity: ts[req.item_id],
    discountQuantity: 0,
    itemPrice: getItemPrice(req.item_id, items),
    cartPrice,
    discountPrice: req.discount_amount,
    curAmtSaved: 0
  }
  body = calcSpecificDiscount(body);
  const { curAmtSaved } = body;
  return (curAmtSaved && curAmtSaved > 0) ? Number(curAmtSaved.toFixed(2)) : 0;
}

export function getDiscount(state, specificDiscount) {
  const dis = state.discount.discountsData;
  // multiplied by -1 x offset to counter browser-retrieved time zone
  var date = moment(state.date.selectedDate).add(-1 * moment().utcOffset(), 'm').tz(state.bookingLocation.selectedLocation.time_zone);

  const selStations = state.station.selectedStations;
  const statsData = state.station.stationsData;
  const selPartys = state.partyRoom.selectedPartyRooms;
  const prData = state.partyRoom.partyRoomsData;

  let debugging = false;

  let returning = {
    timeslots: {},
    evaluateCart: false,
    evaluateCartDiscount: {},
    title: '',
    id: '0',
    total: 0
  };

  if (dis && dis.discounts && date) {

    let applicableDiscounts = [];

    if(debugging) console.log('isPromoDiscount:', state.discount.isPromoDiscount);

    // checking amount saved for specific discount
    if (specificDiscount) {
      applicableDiscounts = [specificDiscount];
    }
    else if (state.discount.isPromoDiscount) {
      // is promo discount (better than others), won't appear in normal applicableDiscounts (in else clause)
      // because it is not applied_autamatically
      applicableDiscounts = dis.discounts.filter(discount => {
        return discount.discount_id === state.discount.selectedDiscountId;
      });
    }
    else {

      // var newDate = new Date(date);
      // date.setHours(date.getHours() + 12);
      if(debugging) console.log('DATE:', date);

      applicableDiscounts = dis.discounts.filter(discount => {
        const applyAuto = discount.applied_automatically;

        const applicableDay = (discount.applicable_days.find(day => {
          return day.day === date.day();
        })).redeemable;

        const isActive = (moment(discount.active_start).valueOf() <= moment().valueOf())
          && (moment().valueOf() <= moment(discount.active_end).valueOf());

        const isApplicable = (moment(discount.applicable_start).valueOf() <= date.valueOf())
          && (date.valueOf() < moment(discount.applicable_end).valueOf());

        if(debugging) {
          console.log(discount.name);
          console.log('selected date:', date.tz(state.bookingLocation.selectedLocation.time_zone).format());
          console.log('applicable_end:', moment(discount.applicable_end).tz(state.bookingLocation.selectedLocation.time_zone).format());
        }

        const requirementsAccepted = discount.requirements.filter(req => {
          const cartCeCalCam = ((req.applicable_to_id === '2' || req.applicable_to_id === '3') 
                          && (req.condition_id === '2' || req.condition_id === '3' || req.condition_id === '4'))
                          && (discount.evaluate_cart || !req.is_percent);
          const cartFego = (req.applicable_to_id === '2' && req.condition_id === '1') && !req.is_percent;
          const groupCeCal = req.applicable_to_id === '1' && req.condition_id === '1';
          return cartCeCalCam || cartFego || groupCeCal;
        });
        if (debugging && !requirementsAccepted) console.error('requirements not accepted:', discount);

        return applyAuto && applicableDay && isActive && isApplicable && requirementsAccepted;
      });
    }

    if (selStations) {
      const selTimeslots = { ...selStations, ...selPartys };
      let bestDiscountAmt = 0;
      let bestDiscount = {};
      let items = {};
      let totalCartPrice = 0;

      if (statsData && statsData.stations) items = { ...statsData.stations };
      if (prData && prData.partyRooms) items = { ...items, ...prData.partyRooms };

      for (let timeslot in selTimeslots) {
        if (selTimeslots.hasOwnProperty(timeslot)) {
          const ts = selTimeslots[timeslot];
          for (let itemId in ts) {
            if (ts.hasOwnProperty(itemId)) {
              const itemPrice = getItemPrice(itemId, items)
              if (itemPrice !== -1) totalCartPrice += itemPrice * ts[itemId];
            }
          }
        }
      }

      // go through all discounts to see which one is the best
      for (let discountId in applicableDiscounts) {
        if (applicableDiscounts.hasOwnProperty(discountId)) {
          const discount = applicableDiscounts[discountId];
          const reqs = discount.requirements;
          let curAmtSaved = 0;  // current discount amount
          let ttlNumReqsPassed = 0; // total number of times all requirements for this discount passed
          let numReqPassed = []; // number of times each specific requirement passed
          let curInfo = {}; // info for each timeslot to be put in and returned
          let totalItems = {};
          let appliedAlready = false;

          if (debugging) console.log('----------------', discount.name);

          for (let i = 0; i < reqs.length; i++) {
            const req = reqs[i];
            const itmId = req.item_id;

            if (debugging) console.log('selTimeslots:', selTimeslots);

            for (let timeslot in selTimeslots) {
              if (selTimeslots.hasOwnProperty(timeslot)) {
                const ts = selTimeslots[timeslot];

                if (debugging) console.log('ts:', ts);
                if (!numReqPassed[i]) numReqPassed[i] = 0;
                if (debugging) console.log('itmId', itmId);

                if (ts.hasOwnProperty(itmId)) {
                  if (discount.evaluate_cart) {
                    if (totalItems[itmId]) totalItems[itmId] += ts[itmId];
                    else totalItems[itmId] = ts[itmId];
                  }
                  else if (ts[itmId] >= reqs[i].item_quantity && reqs[i].item_quantity !== 0) { // if amt selected >= required amt
                    numReqPassed[i] += Math.floor(ts[itmId] / reqs[i].item_quantity);
                  }
                  else if (ts[itmId] <= reqs[i].item_quantity && reqs[i].item_quantity !== 0 && reqs[i].condition_id === '4') { // if amt selected <= required amt
                    numReqPassed[i] += Math.ceil(ts[itmId] / reqs[i].item_quantity);
                  }
                }
              }
            }

            if (discount.evaluate_cart && totalItems.hasOwnProperty(itmId)) {
              if (totalItems[itmId] >= reqs[i].item_quantity) {
                numReqPassed[i]++;
                if (!appliedAlready || req.applicable_to_id !== '2') curAmtSaved += calcAmtSaved(req, totalItems, items, totalCartPrice);
                if (req.applicable_to_id === '2') appliedAlready = true;
              }
            }

          }

          if (debugging) console.log('numReqPassed', numReqPassed);
          if (numReqPassed.length === 0) ttlNumReqsPassed = 0;
          else ttlNumReqsPassed = Math.min(...numReqPassed);

          if (debugging) console.log('ttlNumReqsPassed', ttlNumReqsPassed);

          let alreadyChecked = {}; // object of timeslots as keys, each property is an array of itemIds
          let totalItemsReqsPassed = {}; // object of itemIds as keys, each property is an int for quantity (for FEGO)

          for (let i = 0; i < reqs.length; i++) {
            const req = reqs[i];
            const itmId = req.item_id;

            // FEGO
            totalItemsReqsPassed[itmId] = req.item_quantity * ttlNumReqsPassed;

            for (let j = 0; j < ttlNumReqsPassed; j++) {
              for (let timeslot in selTimeslots) {
                if (selTimeslots.hasOwnProperty(timeslot)) {
                  const ts = selTimeslots[timeslot];

                  if (ts.hasOwnProperty(itmId)
                    && !(alreadyChecked.hasOwnProperty(timeslot) && alreadyChecked[timeslot].includes(itmId))
                    && ((ts[itmId] >= reqs[i].item_quantity && (req.condition_id === '1' || req.condition_id === '2' || req.condition_id === '3')) ||
                        (req.condition_id === '4'))
                    && !discount.evaluate_cart
                    && (
                      totalItemsReqsPassed[itmId] > 0
                      || req.condition_id !== '1' // if it's not FEGO, we don't CARE!!
                    )) {

                    const appliedQuantity = Math.min((ts[itmId] - ts[itmId] % req.item_quantity), totalItemsReqsPassed[itmId]);
                    if (debugging) console.log('appliedQuantity', appliedQuantity);
                    totalItemsReqsPassed[itmId] -= appliedQuantity;
                    if (debugging) console.log('totalItemsReqsPassed[itmId]', totalItemsReqsPassed[itmId]);

                    if (!curInfo.hasOwnProperty(timeslot)) curInfo[timeslot] = {};
                    curInfo[timeslot][itmId] = {
                      id: discount.discount_id,
                      name: discount.title,
                      appliedQuantity,
                      requirements: { ...req }
                    };
                    if (!appliedAlready || req.applicable_to_id !== '2') curAmtSaved += calcAmtSaved(req, ts, items, totalCartPrice);
                    if (req.applicable_to_id === '2') appliedAlready = true;

                    if (alreadyChecked.hasOwnProperty(timeslot)) alreadyChecked[timeslot].push(itmId);
                    else alreadyChecked[timeslot] = [itmId];

                    break;
                  }
                }
              }
            }
          }

          if (debugging) console.log('curAmtSaved', curAmtSaved);

          // if this discount is better than the best we already have, make this the best
          if (ttlNumReqsPassed > 0 && curAmtSaved >= bestDiscountAmt) {
            bestDiscountAmt = curAmtSaved;
            bestDiscount = {
              evaluateCart: discount.evaluate_cart,
              evaluateCartDiscount: discount.evaluate_cart ? {
                reqs: discount.requirements,
                total: curAmtSaved
              } : {},
              timeslots: curInfo,
              title: discount.title,
              id: discount.discount_id,
              total: curAmtSaved
            }
          }
        }
      }

      returning = { ...returning, ...bestDiscount };

    }

    if (debugging) console.log('returning', returning);
    return returning;
  }
  else return;
}
